import { AccountInfo } from "@azure/msal-browser";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Claims } from "../helpers/claimHelper";

export interface UserAccountState {
    accounts: AccountInfo[];
    isUserLoggedIn: boolean;
    userRole: string;
    userWebId: string;
    claims: Claims;
    accountTypes: AccountType[];
}

enum AccountType {
    SuperAdmin = "Super Admin",
    Facilitator = "Facilitator",
    Admin = "Admin",
    Clinician = "Clinician & Clinical Staff",
    Researcher = "Researcher",
    DataQualityAnalyst = "Data Quality Analyst"
}

export const initialState: UserAccountState = {
    accounts: [],
    isUserLoggedIn: false,
    userRole: "guest",
    userWebId: "",
    claims: {},
    accountTypes: []
};

const userAccountSlice = createSlice({
    name: "userAccount",
    initialState,
    reducers: {
        updateAccounts(state, action: PayloadAction<AccountInfo[]>) {
            state.accounts = action.payload;
        },
        updateIsUserLoggedIn(state, action: PayloadAction<boolean>) {
            state.isUserLoggedIn = action.payload;
        },
        updateIserveUserRole(state, action: PayloadAction<string>) {
            state.userRole = action.payload;
        },
        updateUserWebId(state, action: PayloadAction<string>) {
            state.userWebId = action.payload;
        },
        updateUserClaims(state, action: PayloadAction<Claims>) {
            state.claims = action.payload;
        }
    }
});

export const { updateAccounts, updateIsUserLoggedIn, updateIserveUserRole, updateUserWebId, updateUserClaims } =
    userAccountSlice.actions;
export default userAccountSlice.reducer;
